import { OrgPlanPage } from '@/shared/ui/components'
import type { BillingCycle, OrgType } from '../types'

export type FeaturePageStepProps = {
  orgType: OrgType
  trialDays: number | null
  onContinue: (tier: BillingCycle) => void
  fullBleed?: boolean
}

export function FeaturePageStep(props: FeaturePageStepProps) {
  return <OrgPlanPage {...props} />
}
